import {
  createActionButtons,
  createSlugElement,
  createStatusTag,
  createTypeTag,
} from "./constants";

export const transformKeywordsToRowData = (
  keywords,
  onEdit,
  onDelete,
  showCategory = true
) => {
  return keywords.map((keyword) => ({
    id: keyword.id,
    name: keyword.name,
    slug: createSlugElement(keyword.slug),
    type: createTypeTag(keyword.type),
    ...(showCategory && { category: keyword.category || "-" }),
    status: createStatusTag(keyword.deleted),
    actions: createActionButtons(keyword, onEdit, onDelete),
  }));
};
